export const LAYOUT_HEADER_HEIGHT = 64;
export const LAYOUT_HORIZONTAL_PADDING = '3vw';
export const LAYOUT_VERTICAL_PADDING = 20;
export const LAYOUT_MAX_WIDTH = 1600;